const loyaltyCreditStatusForSelection = ['Created', 'Completed', 'Cancelled'].map((key) => {
	return { id: key, name: key };
});

const loyaltyCreditActionForSelection = ['Issue', 'Redeem', 'IssueCancel', 'RedeemCancel', 'Buy'].map((key) => {
	return { id: key, name: key };
});

const loyaltyCreditOwnerTypeForSelection = ['Purchase', 'Refund'].map((key) => {
	return { id: key, name: key };
});

export { loyaltyCreditStatusForSelection };
export { loyaltyCreditActionForSelection };
export { loyaltyCreditOwnerTypeForSelection };
